const likeButtonModulePayload = () => ({
  page_type: 'post',
  module: 'like_button',
  landing_path: window.location.pathname,
  target_type: 'like_button',
  target_id: window.postInfo.id,
  position: 0,
});

const likePost = () => {
  const likeForms = document.querySelectorAll("#post-detail .post-like");

  likeForms.forEach((element) => {
    element.addEventListener("ajax:success", (event) => {
      const [data, status, xhr] = event.detail;
      if (data['status'] === 'saved'){
        element.classList.add('focus')

        if (window.trackingEvent && window.postInfo) {
          window.trackingEvent.track_module_click(likeButtonModulePayload())
        }
      } else {
        element.classList.remove('focus')
      }

      var likedCountEl = document.getElementById('post-liked-count')
      var likedCount   = parseInt(data['count'])

      if(likedCountEl && likedCount != NaN) {
        likedCountEl.innerText = likedCount;
      }
    });
  });
}

export { likePost };
